import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { useOccDisplayText } from '../../../context/occ/hooks/use-occ-display-text';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { getFilmStatusLabel } from './utils/get-film-status-label';
const b = bemClassBuilder('v-film-status');
export const FilmStatus = observer(() => {
    const { film: filmDisplayText } = useOccDisplayText();
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { filmAvailability } = useFilmContext();
    if (!filmAvailability)
        return enableSkeletonLoadingIndicators ? _jsx(FilmStatusSkeleton, {}) : null;
    const status = getFilmStatusLabel(filmAvailability, filmDisplayText);
    if (!status)
        return null;
    return _jsx("span", Object.assign({ className: b.block() }, { children: status }));
});
FilmStatus.displayName = 'FilmStatus';
export const FilmStatusSkeleton = () => _jsx("span", { className: b.block({ skeleton: true }) });
FilmStatusSkeleton.displayName = 'FilmStatusSkeleton';
/**
 * The **Film Status** component displays a film's status.
 */
export const FilmStatusComponent = withComponentWrapper(FilmStatus, {}, () => true);
